angular.module('impactx.dialog').service('ProductEuelService', [
    '$mdDialog',
    ProductEuelService
]);

function ProductEuelService($mdDialog) {

    function showEuel(event, tab, euel) {
        event.stopPropagation();
        $mdDialog.show({
            controller: "ProductEuelCtrl",
            controllerAs: "productEuelCtrl",
            templateUrl: "modules/product/templates/product-euel.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                selectedTab: tab,
                euel: euel
            }
        })
    }


    return {
        showEuel: showEuel
    }
}